import React from 'react';
import DocumentHead from '../shared/DocumentHead';
import Header from '../shared/Header';

interface NotFoundPageProps {
    message?: string;
}

const NotFoundPage: React.FC<NotFoundPageProps> = ({
    message = 'Page not found.'
}) => {
    return (
        <>
            <DocumentHead title=' - not found' />
            <Header headerClassName='mini'>
                <p>{message}</p>
            </Header>
        </>
    );
};

export default NotFoundPage;
